import { render, staticRenderFns } from "./ValidationRuleEventModal.vue?vue&type=template&id=47ed8224"
import script from "./ValidationRuleEventModal.vue?vue&type=script&lang=js"
export * from "./ValidationRuleEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports